module.exports = __webpack_public_path__ + "static/media/Benevento.655a29ca.png";